import "./LeftSearch.css";
import React, { useEffect, useState, useContext } from 'react';
import { textsearch, dataList } from '../visualization/twitter-app';
import { faChevronRight, faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AppContext from './AppContext';

function LeftSearch() {

    const dataState = useContext(AppContext);

    const [iconShowGrid, setIconShowGrid] = useState(false);

    let hide = iconShowGrid? ' hide':'';

    useEffect(() => {
        textsearch()
            .element('tweets-text-search')
            .execute()
            .catch(() => {
                console.log(`There was an error with widget tweets-text-search`)
            })
        dataList()
            .element('tweets-data-list')
            .execute()
            .catch(() => {
                console.log(`There was an error with widget tweets-data-list`)
            })
    }, [])

    const showGridAnimated = () => {
        setIconShowGrid(!iconShowGrid);
      }

    return (
        <div className={`left-search-container${hide}`}>
            <div className="floating-left-search" onClick={showGridAnimated}> 
                <FontAwesomeIcon icon={iconShowGrid? faChevronLeft : faChevronRight}/> 
            </div>
            <div className="top-search col-12 py-3">
                {dataState.esError && <a className="ES-error"></a>}
                {!dataState.esError && <div id="tweets-text-search" className="text-search"></div>}
            </div>
            {/* <Divider /> */}
            <div className="table-container col-12 pt-3" >
                {dataState.esError && <a className="ES-error">Error: No Living connections. Contact the site administrator</a>}
                {!dataState.esError && <div id="tweets-data-list" style={{flex:1}}></div> }
            </div>
        </div>
    );
}

export default LeftSearch;